// extracted by mini-css-extract-plugin
module.exports = {"Container":"featured-offer-brand_Container__VcS_5","Small":"featured-offer-brand_Small__1xqhW"};